import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';

export default function FrequencySelector({ item, setItem, disabled }) {
    if (!item.recurring) return null;

    const handleFrequencyChange = (event) => {
        setItem({
            ...item,
            frequency: event.target.value,
            unit: 'day',
            customFrequency: 1,
        });
    };

    return (
        <FormControl fullWidth>
            <Select sx={{ borderRadius: 0, borderTop: 'none' }} disabled={disabled} value={item.frequency} onChange={handleFrequencyChange}>
                <MenuItem value={1}>Every Day</MenuItem>
                <MenuItem value={2}>Every Other Day</MenuItem>
                <MenuItem value={3}>Every 3 Days</MenuItem>
                <MenuItem value={7}>Weekly</MenuItem>
                <MenuItem value={0}>Custom</MenuItem>
            </Select>
        </FormControl>
    );
}
